@import '@client/theme/theme.less';

.featureCards {
  :global(.ant-card) {
    height: 100%;
  }
}
